import React, { useEffect } from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

/**
 * HoC que implementa IntersectionObserver
 */
const InViewObserver = ({ as = 'div', threshold = 1.0, rootMargin = '0px', children, onChange = null, ...props }) => {
  const [entry, setNode] = useIntersectionObserver({
    rootMargin,
    threshold
  });
  useEffect(() => {
    if (typeof onChange === 'function') {
      onChange(entry.intersectionRatio > 0, entry);
    }
  }, [entry, onChange]);

  const handleNode = (node = null) => {
    if (node) {
      setNode(node);
    }
  };
  return React.createElement(
    as,
    {
      ref: handleNode,
      ...props
    },
    children
  );
};

export { InViewObserver };
